import Vue from 'vue';
import Router from '@/router';
import VueI18n from '@/libs/i18n/index';

// axios
import axios from 'axios';

import {
  baseURL, TOKEN_KEY, PROFILE_KEY, LANG,
} from './acl/config';

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: baseURL,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});
let nameRoute = ''

axiosIns.interceptors.request.use((request) => {
  if (request.method === 'post') {
    if (request.data) {
      if (Object.prototype.hasOwnProperty.call(request.data, 'englishName')) {
        request.data.englishName = request.data.englishName || request.data.arabicName;
      }
    }
  }
  if (request.url === 'User/login') {
    nameRoute = 'admin'
  } else {
    nameRoute = 'user'
  }
  const token = window.localStorage.getItem(TOKEN_KEY);
  const lang = window.localStorage.getItem(LANG);
  // const branchId = window.localStorage.getItem(BRANCH_ID);
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  request.headers.Language = lang || 'en';
  // request.headers.BranchId = branchId;
  if (request.method === 'get' && request.url === 'Items/data-migration') {
    request.responseType = 'arraybuffer';
    request.headers.Accept = 'application/octet-stream'
  }
  if (request.method === 'post' && request.url === 'Items/data-migration') {
    request.headers.ContentType = 'multipart/form-data'
  }

  return request;
});

axiosIns.interceptors.response.use(undefined, (error) => {
  // const token = window.localStorage.getItem(TOKEN_KEY)
  if (error.response.status === 401) {
    // const lang = window.localStorage.getItem(LANG);
    window.localStorage.setItem(TOKEN_KEY, '');
    window.localStorage.removeItem(PROFILE_KEY);
    Vue.swal({
      icon: 'error',
      title: VueI18n.t('error'),
      text: error.response.data.title === 'Unauthorized' ? 'خطأ في اسم المستخدم او كلمة المرور' : error.response.data.detail,
      timer: 2000,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
    });
    if (nameRoute === 'admin') {
      Router.push('/admin/login');
    } else {
      Router.push('/login');
    }
  } else if ([400, 409].includes(error.response.status)) {
    Vue.swal({
      icon: 'error',
      title: VueI18n.t('error'),
      text: error.response.data.detail,
      timer: 2000,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
    });
  }
  return Promise.reject(error);
});

Vue.prototype.$http = axiosIns;

export default axiosIns;
